import { ArrowRight, Check } from "lucide-react";
import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { ButtonLabel } from "../components/ButtonLabel";
import { apiRequest, describeApiError } from "../lib/api";
import { AuthLayout, FormError } from "./AuthPages";

const LISTS: Record<string, { title: string; detail: string }> = {
  price_alerts: {
    title: "Avisos de baja de precio",
    detail: "Dejarás de recibir correos cuando baje el precio de un viaje que guardaste. Tus viajes guardados se quedan como están."
  }
};

/**
 * Landing page for the unsubscribe link in an email footer. It asks before acting: link scanners
 * open every URL in a message, and a GET that unsubscribed would opt customers out on their own.
 * Mailbox providers' one-click button POSTs to the API directly and never reaches this page.
 */
export function EmailUnsubscribePage() {
  const [params] = useSearchParams();
  const list = params.get("l") ?? "";
  const copy = LISTS[list];
  const [state, setState] = useState<"idle" | "busy" | "done">("idle");
  const [error, setError] = useState<string[] | null>(null);

  const confirm = async () => {
    setError(null); setState("busy");
    try {
      const query = new URLSearchParams({ u: params.get("u") ?? "", l: list, t: params.get("t") ?? "" });
      await apiRequest(`/api/v1/email/unsubscribe?${query.toString()}`, { method: "POST", retryAuth: false });
      setState("done");
    } catch (cause) {
      setError(describeApiError(cause, "No pudimos procesar tu baja. Escríbenos y la hacemos por ti."));
      setState("idle");
    }
  };

  return (
    <AuthLayout kicker="Preferencias de correo" headline="Tú decides qué te escribimos." promise="Los correos sobre tu cuenta, tu dinero y tus reservaciones siguen llegando: son parte del servicio.">
      {!copy ? (
        <div className="auth-heading"><h2>Enlace no válido</h2><p>Este enlace para darte de baja no es válido o está incompleto. Escríbenos a daniel@aventuria.mx y te ayudamos.</p></div>
      ) : state === "done" ? (
        <div className="auth-heading">
          <h2><Check size={22} aria-hidden="true" /> Listo, te diste de baja</h2>
          <p>Ya no recibirás «{copy.title}». Puedes volver a activarlos desde Guardados cuando quieras.</p>
          <p><Link to="/guardados">Ir a mis viajes guardados</Link></p>
        </div>
      ) : (
        <>
          <div className="auth-heading"><h2>{copy.title}</h2><p>{copy.detail}</p></div>
          <FormError messages={error} />
          <button className="primary-button full" type="button" onClick={confirm} disabled={state === "busy"}>
            <ButtonLabel busy={state === "busy"} busyLabel="Procesando" label="Darme de baja" icon={<ArrowRight size={16} aria-hidden="true" />} />
          </button>
        </>
      )}
    </AuthLayout>
  );
}
